import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// From https://github.com/arjunkomath/react-giphy-picker
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroller';
import _ from 'lodash';

var _default = /*#__PURE__*/function (_Component) {
  _inherits(_default, _Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadTrendingGifs", function (offset) {
      var _this$state = _this.state,
          giphyTrendingUrl = _this$state.giphyTrendingUrl,
          page = _this$state.page,
          loading = _this$state.loading;

      if (loading) {
        return;
      }

      var url = giphyTrendingUrl;

      if (offset) {
        url += "&offset=".concat(offset);
      }

      _this.setState({
        loading: true
      });

      fetch(url, {
        method: 'get'
      }).then(function (res) {
        return res.json();
      }).then(function (response) {
        var gifs = response.data.map(function (g) {
          return g.images;
        });
        var hasMore = true;
        var _response$pagination = response.pagination,
            total_count = _response$pagination.total_count,
            count = _response$pagination.count,
            offset = _response$pagination.offset;

        if (total_count <= count + offset) {
          hasMore = false;
        }

        _this.setState({
          gifs: _this.state.gifs.concat(gifs),
          page: page + 1,
          loading: false,
          hasMore: hasMore
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_searchGifs", function (offset) {
      var _this$state2 = _this.state,
          giphySearchUrl = _this$state2.giphySearchUrl,
          searchValue = _this$state2.searchValue,
          page = _this$state2.page,
          loading = _this$state2.loading;

      if (searchValue.length < 1) {
        return;
      }

      if (loading) {
        return;
      }

      var url = "".concat(giphySearchUrl, "&q=").concat(searchValue.replace(' ', '+'));

      if (offset) {
        url += "&offset=".concat(offset);
      }

      _this.setState({
        loading: true
      });

      fetch(url, {
        method: 'get'
      }).then(function (res) {
        return res.json();
      }).then(function (response) {
        var gifs = response.data.map(function (g) {
          return g.images;
        });
        var hasMore = true;
        var _response$pagination2 = response.pagination,
            total_count = _response$pagination2.total_count,
            count = _response$pagination2.count,
            offset = _response$pagination2.offset;

        if (total_count <= count + offset) {
          hasMore = false;
        }

        _this.setState({
          gifs: _this.state.gifs.concat(gifs),
          page: page + 1,
          loading: false,
          hasMore: hasMore
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGiphySelect", function (gif) {
      _this.props.onSelected(gif);
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchChange", function (event) {
      var value = event.target.value;
      event.stopPropagation();

      _this.setState({
        searchValue: value,
        page: 0,
        gifs: []
      });

      if (value) {
        _this.searchGifs();
      } else {
        _this.loadTrendingGifs();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();

        _this.reset();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      _this.setState({
        searchValue: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      var _this$state3 = _this.state,
          searchValue = _this$state3.searchValue,
          page = _this$state3.page;
      var nextPage = page + 1;
      var offset = (Number(nextPage) - 1) * 25;

      if (searchValue) {
        _this.searchGifs(offset);
      } else {
        _this.loadTrendingGifs(offset);
      }
    });

    var giphyRating = props.rating ? props.rating : 'g';
    var giphyLang = props.language ? props.language : 'en';
    _this.state = {
      gifs: [],
      searchValue: '',
      loading: false,
      hasMore: true,
      giphySearchUrl: "https://api.giphy.com/v1/gifs/search?rating=".concat(giphyRating, "&lang=").concat(giphyLang, "&api_key=").concat(_this.props.apiKey),
      giphyTrendingUrl: "https://api.giphy.com/v1/gifs/trending?rating=".concat(giphyRating, "&lang=").concat(giphyLang, "&api_key=").concat(_this.props.apiKey),
      page: 0
    };
    console.log('The Giphy API URLs are:', {
      trending: _this.state.giphyTrendingUrl,
      search: _this.state.giphySearchUrl
    });
    _this.searchGifs = _.debounce(_this._searchGifs, 500);
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadTrendingGifs();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state4 = this.state,
          gifs = _this$state4.gifs,
          loading = _this$state4.loading,
          hasMore = _this$state4.hasMore;

      var rowChunks = _.chunk(_toConsumableArray(gifs), 9);

      return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(GiphyPickerWrapper, {
        className: 'giphy-picker'
      }, /*#__PURE__*/React.createElement(Input, {
        name: "giphy-search",
        type: "text",
        style: this.props.inputStyle,
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        onChange: this.onSearchChange,
        value: this.state.searchValue,
        onKeyDown: this.onKeyDown,
        placeholder: this.props.placeholder
      }), /*#__PURE__*/React.createElement(GiphyWrapper, null, /*#__PURE__*/React.createElement(InfiniteScroll, {
        loadMore: this.loadMore,
        hasMore: !loading && hasMore,
        initialLoad: false,
        useWindow: false,
        threshold: 700
      }, !rowChunks.length && loading && this.props.loader, /*#__PURE__*/React.createElement(GiphyWrapperRow, null, rowChunks.map(function (gifs, i) {
        return /*#__PURE__*/React.createElement(GiphyColumn, {
          key: i
        }, gifs.map(function (g, j) {
          var gifUrl = g.fixed_width.url;
          return /*#__PURE__*/React.createElement(Giphy, {
            key: j,
            style: {
              width: '100%',
              height: Number(g.fixed_width.height),
              backgroundColor: _this2.props.imagePlaceholderColor
            },
            src: gifUrl,
            onClick: function onClick() {
              _this2.onGiphySelect(g);
            }
          });
        }));
      }))))), this.props.children, /*#__PURE__*/React.createElement("a", {
        href: "https://support.giphy.com/hc/en-us/sections/360002879511-About-GIPHY",
        target: "_blank",
        rel: "noopener"
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          objectFit: 'contain',
          padding: 10
        },
        src: "https://s3.amazonaws.com/likeabucket/user_upload/3/BJiAFYlaN.png"
      })));
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        apiKey: '',
        placeholder: 'Search for GIFs',
        imagePlaceholderColor: '#E3E3E3',
        loader: /*#__PURE__*/React.createElement("p", null, "Loading...")
      };
    }
  }]);

  return _default;
}(Component);

export { _default as default };
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n"])));
var GiphyPickerWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  padding: 10px;\n  border: 1px solid #f1f1f1;\n  border-radius: 4px;\n  background: white;\n  width: 420px;\n  height: 400px;\n  z-index: 100;\n"])));
var GiphyWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  overflow-y: scroll;\n  height: calc(100% - 35px);\n  margin-top: 5px;\n"])));
var GiphyWrapperRow = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 4px;\n"])));
var GiphyColumn = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  flex: 50%;\n  max-width: 50%;\n  padding: 0 4px;\n  cursor: pointer;\n"])));
var Giphy = styled.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  border-radius: 3px;\n  margin-top: 8px;\n  box-sizing: border-box;\n  vertical-align: middle;\n"])));
var Input = styled.input(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: 1px solid #ddd;\n  border-radius: 2px;\n  color: inherit;\n  font-size: 14px;\n  height: auto;\n  line-height: 1;\n  margin: 0;\n  padding: 7px 10px;\n  width: 100%;\n  display: block;\n  &:focus {\n    outline: none;\n  }\n  ::placeholder,\n  ::-webkit-input-placeholder {\n    color: rgb(141, 148, 158);\n  }\n  :-ms-input-placeholder {\n    color: rgb(141, 148, 158);\n  }\n"])));